<template>
  <div class="mw6">
    <ul class="list ma0 pa0">
      <li v-for="(param, index) in report.params" :key="index" class="flex flex-row mb2">
        <identificator v-if="param.type === 'integer'" :value="getParam(param.name)" @input="setParam(param.name, $event, index)" :title="param.title"/>
        <date-range v-if="param.type === 'date_range'" :value="getParam(param.name)" @input="setParam(param.name, $event, index)" :title="param.title"/>
      </li>
    </ul>
    <file-type :types="report.types" v-model="type"/>
  </div>
</template>

<script>
import Identificator from '@/components/report/parameters/Identificator.vue'
import DateRange from '@/components/report/parameters/DateRange.vue'
import FileType from '@/components/report/parameters/FileType.vue'

export default {
  props: ['report', 'value'],
  components: {
    Identificator,
    DateRange,
    FileType
  },
  watch: {
    type: {
      immediate: true,
      handler: function (val, oldVal) {
        this.$nextTick(() => { this.fireSettings() })
      }
    }
  },
  data () {
    return {
      params: {},
      type: 0
    }
  },
  methods: {
    getParam (paramName) {
      return this.params[paramName]?.value
    },
    setParam (paramName, value, index) {
      this.$set(this.params, paramName, { value, index })
      this.fireSettings()
    },
    fireSettings () {
      var settings = {
        templateId: this.report.templateId,
        valid: true,
        params: {},
        type: this.report.types[this.type],
        fileName: this.report.fileName
      }

      for (var pName in this.params) {
        const { value: { input, valid }, index } = this.params[pName]
        settings.valid = settings.valid && valid
        if (settings.valid) {
          if (pName === 'dates_range') {
            // параметр 'dates_range' преобразуется в два параметра
            settings.params[this.report.params[index].start] = input.start
            settings.params[this.report.params[index].end] = input.end
          } else {
            settings.params[pName] = input
          }
        }
      }

      // проверяем установлены ли все необходимые параметры
      // возможно, тут будут опциональные параметры
      settings.valid = settings.valid && Object.keys(settings.params).length >= Object.keys(this.report.params).length

      this.$emit('report', settings)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-range-grid {
  display: grid;
  grid-template-columns: auto 50px;
  grid-template-rows: 35px;
}
.date-range-grid-empty {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 35px;
}
</style>
